import React, { useEffect, useMemo, useState, useRef } from "react";
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';
import $ from 'jquery';
import '../Pages/Css/trafico.css';
import { FaClock } from "@react-icons/all-files/fa/FaClock";
import { FaRoute } from "@react-icons/all-files/fa/FaRoute";
import { FaLock } from "@react-icons/all-files/fa/FaLock";
import { motion } from 'framer-motion';
import axios from "../utils/axiosConfig";
import { registerOpenStreetMap } from "../utils/openStreetMapType";
import { FaInfoCircle } from "@react-icons/all-files/fa/FaInfoCircle";
import { FaFileExcel } from "@react-icons/all-files/fa/FaFileExcel";
import ModalInfromacionExtra from "../components/modals/modalInfromacionExtra";
import BaseModalAuto2 from "../components/modals/BaseModalAuto2";
import Swal from "sweetalert2";
import { Spinner } from "reactstrap";
import ExcelJS from "exceljs";
var miStorage = window.localStorage;
const PUBLIC_ASSET_BASE_URL = "https://cargotronics.com";

const Modal = ({ isOpen, onClose, contratoVar, aleatorio, children, images, monitoreo, consolidado, videos, streaming, valitronics, checkList }) => {
  let map = null;
  let directionsService;
  var infowindow = null;
  const google = window.google;
  const [listaMensajes, setListaMensajes] = useState([]);
  const [listaFiltrada, setListaFiltrada] = useState([]);
  const [uniquesGeocerca, setUniquesGeocerca] = useState([]);
  const [geocercaPolygons, setGeocercaPolygons] = useState([]);
  const [infoWindows, setInfoWindows] = useState([]);
  const [selectedMarkerIndex, setSelectedMarkerIndex] = useState(null);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [contratoseleccionado, setContratoseleccionado] = useState(null);
  const [markers, setMarkers] = useState([]);
  const circleRef = useRef(null);
  const markersRef = useRef([]);
  const polylineRef = useRef([]);
  const infoWindowRef = useRef(null);
  const intervalRef = useRef(null);
  const mapRef = useRef(null);
  const [switchValue, setSwitchValue] = useState(false);
  const [switchValueGeo, setSwitchValueGeo] = useState(false);
  const [timeTotal, setTimeTotal] = useState('');
  const [activeTab, setActiveTab] = useState("tabla");
  const [modalInformacionExtra, setModalInformacionExtra] = useState(false);
  const [activeIconFilter, setActiveIconFilter] = useState(null);
  const [loadingSeguimiento, setLoadingSeguimiento] = useState(false);
  const [exportandoExcel, setExportandoExcel] = useState(false);

  const safeSetHtml = (id, html) => {
    const el = document.getElementById(id);
    if (el) {
      el.innerHTML = html;
    }
  };

  const isIntervalActive = () => {
    return intervalRef.current !== null;
  };

  const uniqueIconPaths = useMemo(() => {
    if (!listaMensajes.length) return [];
    const icons = listaMensajes.flatMap((msg) =>
      Object.entries(msg)
        .filter(([k, v]) => k.startsWith("Icon") && v && !v.includes("transparent") && v.includes(".png") && v.includes("images/"))
        .map(([_, url]) => url.substring(1))
    );
    return Array.from(new Set(icons));
  }, [listaMensajes]);

  const filterMarkersByIcon = (iconPath) => {
    if (!iconPath) return;
    setActiveIconFilter(iconPath);
    const filtered = listaMensajes.filter((item) =>
      Object.entries(item)
        .filter(([k]) => k.startsWith("Icon"))
        .some(([_, url]) => url && url.includes(iconPath))
    );
    setListaFiltrada(filtered);
    rutaenMapa(filtered, 1);
  };

  const clearIconFilter = () => {
    setActiveIconFilter(null);
    setListaFiltrada(listaMensajes);
    rutaenMapa(listaMensajes, 1);
  };

  const getIconOptionLabel = (iconPath) => {
    const fileName = String(iconPath || "").split("/").pop() || "";
    const normalized = fileName.replace(/\.(png|gif|jpg|jpeg)$/i, "");
    if (!normalized) return "Icono";

    return normalized
      .replace(/[-_]+/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, (letter) => letter.toUpperCase());
  };

  const resolvePublicAssetUrl = (value, fallbackPrefix = "") => {
    const rawValue = String(value || "").trim();
    if (!rawValue) return "";

    if (/^https?:\/\//i.test(rawValue)) {
      return rawValue;
    }

    let normalizedPath = rawValue
      .replace(/^~\//, "/")
      .replace(/^~/, "/")
      .replace(/^\.\//, "/");

    if (!normalizedPath.includes("/") && fallbackPrefix) {
      normalizedPath = `${fallbackPrefix}${normalizedPath}`;
    }

    if (!normalizedPath.startsWith("/")) {
      normalizedPath = `/${normalizedPath}`;
    }

    return `${PUBLIC_ASSET_BASE_URL}${normalizedPath}`;
  };

  const getImageExtensionFromUrl = (url) => {
    const normalizedUrl = String(url || "").toLowerCase();
    if (normalizedUrl.includes(".jpg") || normalizedUrl.includes(".jpeg")) return "jpeg";
    if (normalizedUrl.includes(".gif")) return "gif";
    return "png";
  };

  const imageUrlToBase64 = async (url) => {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`No se pudo descargar la imagen: ${url}`);
    }

    const blob = await response.blob();
    const base64 = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

    return typeof base64 === "string" ? base64 : "";
  };

  const getExportCellValue = (value) => {
    if (value === null || value === undefined) return "(vacio)";
    if (typeof value === "string" && value.trim() === "") return "(vacio)";
    return value;
  };

  useEffect(() => {
    if (isOpen) {
      setSwitchValue(false);
      setSwitchValueGeo(false);
      // console.log("Contrato reporte abierto: ", contratoVar);
      $("#success-alert").hide();
      $("#danger-alert").hide();
      setListaMensajes([]);
      setListaFiltrada([]);
      setInfoWindows([]);
      setSelectedMarkerIndex(null);
      setMarkers([]);
      setLoadingSeguimiento(true);
      RenderMap();
      setContratoseleccionado(contratoVar);
      ListReports(contratoVar, 0, 1);
      safeSetHtml("dispositivo_segH", contratoVar.FKLokDeviceID);
      safeSetHtml("contrato_segH", contratoVar.ContractID);
      safeSetHtml("cliente_segH", contratoVar.NombreEmpresa);
      safeSetHtml("ruta_segH", contratoVar.DescripcionRuta);

      if (contratoVar.trayecto !== 0) {
        GetPolyline();
      }

      // Solo activa el seguimiento si el switch está activado
      if (switchValue) {
        handleVerSeguimientoClick();
      }
    } else {
      clearInterval(intervalRef.current); // Limpia el intervalo al cerrar el modal
      intervalRef.current = null;
      setLoadingSeguimiento(false);
    }

    return () => {
      // Limpieza al desmontar el componente
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    };
  }, [isOpen]);

  useEffect(() => {
    if (switchValue) {
      handleVerSeguimientoClick();
    }
  }, [switchValue]);

  const RenderMap = () => {
    const coords = { lat: 10.992716649650994, lng: -74.80259436365039 };
    try {
      const el = document.getElementById('map');

      if (el) {
        mapRef.current = new google.maps.Map(el, {
          zoom: 16,
          center: {
            lat: coords.lat,
            lng: coords.lng,
          },
        });
        registerOpenStreetMap(google, mapRef.current);

        return mapRef.current;
      } else {
        return null;
      }
    } catch (error) {
      window.history.go(0);
    }

  }

  const GetPolyline = () => {
    try {
      let data = {
        "id": contratoVar.trayecto
      };
      const json = JSON.stringify(data);
      axios.post(process.env.REACT_APP_SERVER + '/operaciones/getpolylinetrayecto', json, {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
        withCredentials: true
      })
        .then(response => {
          if (response.data.success == true) {
            let rutacompleta = response.data.data[0].Polyline.split("||||");
            for (var i = 0; i < rutacompleta.length; i++) {
              const decodedPath = google.maps.geometry.encoding.decodePath(rutacompleta[i]);

              const polyline = new google.maps.Polyline({
                path: decodedPath,
                geodesic: true,
                strokeColor: "#ffae00ff",
                strokeOpacity: 0.7,
                strokeWeight: 6,
              });
              polyline.setMap(mapRef.current);
            }

          }
        }).catch(error => {
          console.error(error);
        });

    } catch (error) {
      console.error(error);
    }
  }

  const ListReports = (contrato, all, op) => {
    Swal.fire({
      title: 'Cargando posiciones...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    var imagen = 'Cierre'
    if (contrato.Locked == 0) {
      imagen = 'Apertura';
      //document.getElementById("contenedorestadodiv").style.background='#D21F1F';
    } else {
      //document.getElementById("contenedorestadodiv").style.background='#2BA914';
    }
    //document.getElementById("contenedorestado").innerHTML=imagen;
    setLoadingSeguimiento(true);
    try {
      let data = {
        "fechainicio": contrato.fechainicio || contrato.fecha,
        "fechafin": contrato.fechafin,
        "device": contrato.FKLokDeviceID,
        "utcMinutos": 5,
        "allreport": all,
        "tipo": contrato.Active,
        "tipoequipo": contrato.FKLokTipoEquipo,
      };
      const json = JSON.stringify(data);
      axios.post(process.env.REACT_APP_SERVER + '/operaciones/getreportesdevice', json, {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
        withCredentials: true
      })
        .then(response => {
          if (response.data.success == true) {
            Swal.close();
            const prevMarkersList = markersRef.current;
            setMarkers(prevMarkersList);
            const reportes = Array.isArray(response.data.data) ? response.data.data : [];
            console.log('Reportes obtenidos(count):', reportes.length);
            setListaMensajes(reportes);
            setListaFiltrada(reportes);
            rutaenMapa(reportes, op);
          }
        }).catch((error) => {
          setLoadingSeguimiento(false);
          Swal.close();
          Swal.fire({
            icon: 'error',
            title: 'Error al obtener los reportes',
            text: 'Ocurrió un error al obtener las posiciones, por favor intente nuevamente.',
          });
          console.error(error);
        });

    } catch (error) {
      setLoadingSeguimiento(false);
      Swal.close();
      Swal.fire({
        icon: 'error',
        title: 'Error al obtener los reportes',
        text: 'Ocurrió un error al obtener las posiciones, por favor intente nuevamente.',
      });
      console.error(error);
    }
  }

  const rutaenMapa = (lista, op) => {
    if (!Array.isArray(lista) || lista.length === 0) {
      markersRef.current.forEach(({ marker }) => marker.setMap(null));
      markersRef.current = [];
      setMarkers([]);
      setInfoWindows([]);
      setLoadingSeguimiento(false);
      return;
    }
    const promises = lista
      .filter((objeto) => objeto.latitude !== 0 && objeto.longitude !== 0)
      .map((objeto) => {
        return new Promise((resolve) => {
          resolve({
            lat: objeto.latitude,
            lng: objeto.longitude,
            id: objeto.ID,
            html: objeto.HTML,
            ubicacion: objeto.Ciudad,
            icon: objeto.IconLocked,
            iconMapMarker: objeto.IconMapMarker
          });
        });
      });

    Promise.all(promises)
      .then((flightPlanCoordinates) => {

        // Calcula y muestra las flechas de dirección entre todos los marcadores
        for (let i = 0; i < flightPlanCoordinates.length - 1; i++) {
          const directionArrow = new google.maps.Polyline({
            path: [flightPlanCoordinates[i + 1], flightPlanCoordinates[i]],
            geodesic: true,
            strokeColor: "#88A0CF",
            strokeOpacity: 1.0,
            strokeWeight: 2,
            icons: [
              {
                icon: {
                  path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
                  scale: 1,
                  strokeColor: "#082357"
                },
                offset: "50%",
              },
            ],
            map: mapRef.current,
          });
        }
        const markersList = markersRef.current;

        // Eliminar todos los marcadores anteriores
        markersList.forEach(({ marker }) => marker.setMap(null));
        markersRef.current = [];

        // Crear nuevos marcadores
        const markerslist = flightPlanCoordinates.map((coordinate) => {
          // const iconurl = coordinate.icon.includes("opened")
          //   ? "./truckopen.png"
          //   : "./truckclose.png";
          const markerKey = (coordinate.iconMapMarker && String(coordinate.iconMapMarker).trim())
            ? String(coordinate.iconMapMarker).trim()
            : "default"; // pon aquí el nombre real de tu png default (sin .png)

          const iconurl = `images/mapcenter_icons/${markerKey}.png`;
          const marker = new google.maps.Marker({
            position: coordinate,
            map: mapRef.current,
            id: coordinate.id,
            ubicacion: coordinate.ubicacion,
            icon: {
              url: iconurl,
              scaledSize: new google.maps.Size(30, 30),
            },
          });

          const markerInfoWindow = new google.maps.InfoWindow({
            content: coordinate.html,
          });

          marker.addListener("click", () => {
            if (infoWindowRef.current) {
              infoWindowRef.current.close();
            }
            const mensajeActivo =
              listaMensajes.find((item) => item.ID === coordinate.id) ||
              listaFiltrada.find((item) => item.ID === coordinate.id) ||
              null;
            setSelectedMarkerIndex(coordinate.id);
            setSelectedMarker(marker);
            setSelectedMessage(mensajeActivo);
            markerInfoWindow.open(mapRef.current, marker);
            infoWindowRef.current = markerInfoWindow;
          });

          return { marker, markerInfoWindow };
        });

        markersRef.current = markerslist;

        // Actualizar el círculo en el último marcador
        const updateCircleRadius = () => {
          if (markerslist.length > 0) {
            const lastMarker = markerslist[0].marker;
            const zoomLevel = mapRef.current.getZoom(); // Obtener nivel de zoom actual
            const baseRadius = 3; // Radio base en metros
            const maxZoom = 20; // Zoom máximo
            const scaleFactor = Math.pow(2, maxZoom - zoomLevel); // Escala inversa
            const newRadius = baseRadius * scaleFactor;

            // Eliminar el círculo existente si ya está definido
            if (circleRef.current) {
              circleRef.current.setMap(null);
            }

            // Crear un nuevo círculo
            circleRef.current = new google.maps.Circle({
              strokeColor: 'black',
              strokeOpacity: 1,
              strokeWeight: 2,
              fillColor: '#E0E302',
              fillOpacity: 0.8,
              map: mapRef.current,
              center: lastMarker.getPosition(),
              radius: newRadius,
            });
          }
        };

        // Vincular el evento de zoom al mapa
        google.maps.event.addListener(mapRef.current, 'zoom_changed', updateCircleRadius);

        // Llamar a la función inicialmente para establecer el radio correcto
        updateCircleRadius();

        if (op === 1) {
          const bounds = new google.maps.LatLngBounds();
          markerslist.forEach(({ marker }) =>
            bounds.extend(marker.getPosition())
          );
          mapRef.current.fitBounds(bounds);
        } else {
          const switchElement = document.getElementById("autocentrado");
          if (switchElement.checked && markerslist.length > 0) {
            const firstMarker = markerslist[0].marker;
            mapRef.current.setCenter(firstMarker.getPosition());
          }
        }

        setMarkers(markerslist);
        setInfoWindows(
          markerslist.map(({ markerInfoWindow }) => markerInfoWindow)
        );
        setLoadingSeguimiento(false);
      })
      .catch((error) => {
        setLoadingSeguimiento(false);
        console.error(error);
      });
  };



  useEffect(() => {
    // Cerrar todos los InfoWindows cuando el componente se desmonte
    return () => {
      if (infoWindowRef.current) {
        infoWindowRef.current.close();
      }
    };
  }, []);


  const handleMarkerClick = (markerId) => {
    markers.forEach(({ marker, markerInfoWindow }) => {
      markerInfoWindow.close();
      if (marker.id === markerId) {
        const mensajeActivo =
          listaMensajes.find((item) => item.ID === markerId) ||
          listaFiltrada.find((item) => item.ID === markerId) ||
          null;
        markerInfoWindow.open(mapRef.current, marker);
        infoWindowRef.current = markerInfoWindow;
        setSelectedMarkerIndex(markerId);
        setSelectedMarker(marker);
        setSelectedMessage(mensajeActivo);
        mapRef.current.panTo(marker.getPosition()); // Centrar el mapa en el marcador
        mapRef.current.setZoom(16);
      }
    });

  };

  const handleTableRowClick = (markerIndex) => {
    // console.log("entro -> " + markerIndex + " total=" + listaMensajes.length);
    const objeto = listaFiltrada[markerIndex];
    if (!objeto) return;
    setSelectedMessage(objeto);
    handleMarkerClick(objeto.ID);
  };

  const formatFecha = (fecha) => {
    const isoString = new Date(fecha).toISOString();
    const year = isoString.slice(0, 4);
    const month = isoString.slice(5, 7);
    const day = isoString.slice(8, 10);
    const hours = isoString.slice(11, 13);
    const minutes = isoString.slice(14, 16);
    const seconds = isoString.slice(17, 19);
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const handleExportarExcel = async () => {
    const mensajesParaExportar = Array.isArray(listaFiltrada) && listaFiltrada.length > 0
      ? listaFiltrada
      : listaMensajes;

    if (!Array.isArray(mensajesParaExportar) || mensajesParaExportar.length === 0) {
      Swal.fire({
        icon: "info",
        title: "Sin datos para exportar",
        text: "No hay mensajes disponibles para generar el archivo de Excel.",
      });
      return;
    }

    try {
      setExportandoExcel(true);
      const iconColumns = [
        { header: "IconoSatelite", valueKey: "IconSatelite" },
        { header: "IconoMovimiento", valueKey: "IconMoving" },
        { header: "IconoBloqueo", valueKey: "IconLocked" },
        { header: "IconoDesvio", valueKey: "IconDesvio" },
        { header: "IconoRetorno", valueKey: "IconBack" },
        { header: "IconoAlejado", valueKey: "IconAlejado" },
        { header: "IconoMapa", valueKey: "IconMapMarker", fallbackPrefix: "/images/mapcenter_icons/", suffix: ".png" },
      ];

      const headers = [
        "Fecha",
        "Fecha actualizacion",
        "Lugar",
        "Latitud",
        "Longitud",
        "Geocerca",
        "Bateria",
        "GPS",
        "CSQ",
        "Velocidad",
        "Evento",
        ...iconColumns.map((column) => column.header),
      ];

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Mensajes");
      worksheet.addRow(headers);

      worksheet.columns = headers.map((header, index) => ({
        header,
        key: header,
        width: index >= 11 ? 22 : (header === "Geocerca" ? 30 : 18),
      }));

      const imageCache = new Map();
      const getImageId = async (url) => {
        if (!url) return null;
        if (imageCache.has(url)) return imageCache.get(url);

        const base64 = await imageUrlToBase64(url);
        const imageId = workbook.addImage({
          base64,
          extension: getImageExtensionFromUrl(url),
        });
        imageCache.set(url, imageId);
        return imageId;
      };

      for (const mensaje of mensajesParaExportar) {
        const rowValues = [
          getExportCellValue(mensaje?.PositionTime ? formatFecha(mensaje.PositionTime) : ""),
          getExportCellValue(mensaje?.DateTimeActualizacion ? formatFecha(mensaje.DateTimeActualizacion) : ""),
          getExportCellValue(mensaje?.latitude === 0 ? "SIN GPS" : (mensaje?.Ciudad || "")),
          getExportCellValue(mensaje?.latitude),
          getExportCellValue(mensaje?.longitude),
          getExportCellValue(mensaje?.NombreGeocerca || ""),
          getExportCellValue(mensaje?.Battery),
          getExportCellValue(mensaje?.SatelliteCount),
          getExportCellValue(mensaje?.csq),
          getExportCellValue(mensaje?.Speed),
          getExportCellValue(mensaje?.Evento),
          ...iconColumns.map(() => null),
        ];

        const addedRow = worksheet.addRow(rowValues);
        addedRow.height = 52;

        for (let columnIndex = 0; columnIndex < iconColumns.length; columnIndex += 1) {
          const column = iconColumns[columnIndex];
          const rawValue = String(mensaje?.[column.valueKey] || "").trim();
          const excelColumn = 12 + columnIndex;
          worksheet.getCell(addedRow.number, excelColumn).value = null;
          if (!rawValue) continue;

          const valueWithSuffix =
            column.suffix && !rawValue.includes("/")
              ? `${rawValue}${column.suffix}`
              : rawValue;

          const assetUrl = resolvePublicAssetUrl(valueWithSuffix, column.fallbackPrefix || "");
          if (!assetUrl) continue;

          try {
            const imageId = await getImageId(assetUrl);
            if (!imageId) continue;

            worksheet.addImage(imageId, {
              tl: { col: excelColumn - 1 + 0.2, row: addedRow.number - 1 + 0.12 },
              ext: { width: 28, height: 28 },
              editAs: "oneCell",
            });
          } catch (iconError) {
            console.warn("No se pudo incrustar el icono en Excel:", assetUrl, iconError);
          }
        }
      }

      const headerRow = worksheet.getRow(1);
      headerRow.font = { bold: true };
      headerRow.height = 22;

      worksheet.views = [{ state: "frozen", ySplit: 1 }];

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob(
        [buffer],
        { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
      );
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      const contractId = String(contratoVar?.ContractID || "historico").replace(/[^\w-]+/g, "_");
      link.href = url;
      link.download = `historico_${contractId}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exportando mensajes a Excel:", error);
      Swal.fire({
        icon: "error",
        title: "No se pudo exportar",
        text: "Ocurrio un error al generar el archivo de Excel.",
      });
    } finally {
      setExportandoExcel(false);
    }
  };

  const handleVerUltPuntoClick = () => {
    try {
      let obj = listaMensajes[0];
      window.open('https://www.google.com/maps/?q=' + obj.latitude + ',' + obj.longitude + '&z=14', '_blank');
    } catch (error) { }
  };

  const handleSetUltPunto = () => {
    try {
      if (!selectedMarker?.position || !contratoseleccionado?.ContractID) {
        Swal.fire({
          icon: "warning",
          title: "Punto no valido",
          text: "Selecciona un punto valido antes de setearlo.",
          timer: 2200,
          showConfirmButton: false,
        });
        return;
      }

      let data = {
        "lat": selectedMarker.position.lat(),
        "lng": selectedMarker.position.lng(),
        "id": selectedMarker.id,
        "contrato": contratoseleccionado.ContractID
      };
      const json = JSON.stringify(data);
      axios.post(process.env.REACT_APP_SERVER + '/operaciones/setultimopunto', json, {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
        withCredentials: true
      })
        .then(response => {
          if (response.data.success.rowsAffected.length == 1) {
            Swal.fire({
              icon: "success",
              title: "Punto seteado",
              text: "Ultimo punto seteado correctamente.",
              timer: 2200,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "No fue posible setear el punto",
              text: "No se pudo setear el ultimo punto.",
              timer: 2400,
              showConfirmButton: false,
            });
          }
        }).catch(error => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Ocurrio un error al setear el ultimo punto.",
            timer: 2400,
            showConfirmButton: false,
          });
        });

    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrio un error al setear el ultimo punto.",
        timer: 2400,
        showConfirmButton: false,
      });
    }
  };

  const handleSetReporteAutomatico = () => {
    try {
      const mensajeSeleccionado =
        selectedMessage ||
        listaMensajes.find((item) => item.ID === selectedMarkerIndex) ||
        listaFiltrada.find((item) => item.ID === selectedMarkerIndex);
      const ubicacionSeleccionada =
        selectedMarker?.ubicacion ||
        mensajeSeleccionado?.Ciudad ||
        mensajeSeleccionado?.ubicacion ||
        mensajeSeleccionado?.NombreGeocerca ||
        mensajeSeleccionado?.PositionTime;
      const contratoId = contratoseleccionado?.ContractID;

      if (!mensajeSeleccionado && !selectedMarkerIndex) {
        Swal.fire({
          icon: "warning",
          title: "Selecciona un punto",
          text: "Para generar el reporte automático debes seleccionar primero un punto de la lista de mensajes.",
          confirmButtonText: "Entendido"
        });
        return;
      }

      if (!ubicacionSeleccionada || !contratoId) {
        Swal.fire({
          icon: "warning",
          title: "No se pudo identificar la ubicación",
          text: "El punto seleccionado no tiene una ubicación válida para generar el reporte automático.",
          confirmButtonText: "Entendido"
        });
        return;
      }

      let data = {
        "ubicacion": ubicacionSeleccionada,
        "contrato": contratoId
      };
      const json = JSON.stringify(data);
      axios.post(process.env.REACT_APP_SERVER + '/operaciones/setreporteautomatico', json, {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
        withCredentials: true
      })
        .then(response => {
          if (response.data.success == true) {
            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "Reporte automático creado",
              showConfirmButton: false,
              timer: 2500,
              timerProgressBar: true
            });
          } else {
            $("#danger-alert").fadeTo(2000, 500).slideUp(500, function () {
              $("#danger-alert").slideUp(2000);
            });
          }
        }).catch(error => {
          $("#danger-alert").fadeTo(2000, 500).slideUp(500, function () {
            $("#danger-alert").slideUp(2000);
          });
        });

    } catch (error) {
      $("#danger-alert").fadeTo(2000, 500).slideUp(500, function () {
        $("#danger-alert").slideUp(2000);
      });
    }
  };

  const imagesModal = (e) => {
    e.preventDefault();
    images();
  }

  const monitoreoModal = (e) => {
    e.preventDefault();
    monitoreo();
  }

  const consolidadoModal = (e) => {
    e.preventDefault();
    consolidado();
  }

  const streamingModal = (e) => {
    e.preventDefault();
    (streaming || videos)?.();
  }

  const valitronicsModal = (e) => {
    e.preventDefault();
    valitronics();
  }

  const checkListModal = (e) => {
    e.preventDefault();
    checkList();
  }

  const handleSwitchChangeGeo = (event) => {
    const newValue = event.target.checked;
    setSwitchValueGeo(newValue);
  };

  const handleTodoRecorridoClick = () => {
    try {
      ListReports(contratoseleccionado, 1, 1);
    } catch (error) {
      console.error("Error al manejar el recorrido completo:", error);
    }
  };

  const handl50RecorrClick = () => {
    try {
      ListReports(contratoseleccionado, 50, 1); // Llamar a ListReports con 'all' y 'op' como 1 para mostrar todos los reportes
    } catch (error) {
      console.error("Error al manejar el recorrido por 50 ultimos puntos:", error);
    }
  }

  const getPolygonCenter = (polygon) => {
    const path = polygon.getPath();
    let latSum = 0;
    let lngSum = 0;
    const pathCount = path.getLength();

    // Sumar todas las latitudes y longitudes de los vértices
    path.forEach((latLng) => {
      latSum += latLng.lat();
      lngSum += latLng.lng();
    });

    // Calcular el centro
    return new google.maps.LatLng(latSum / pathCount, lngSum / pathCount);
  };

  const mostrarInformacionGeocerca = (geocerca, polygon) => {
    // Usar la función para obtener el centro del polígono
    const center = getPolygonCenter(polygon);

    // Filtrar los mensajes correspondientes a la geocerca seleccionada
    const mensajesDeGeocerca = listaMensajes.filter(
      (mensaje) => mensaje.NombreGeocerca === geocerca.geocerca
    );

    if (mensajesDeGeocerca.length === 0) {
      // Si no hay mensajes asociados a esta geocerca
      return;
    }

    // Encontrar la fecha más antigua y la más reciente
    const fechas = mensajesDeGeocerca.map((mensaje) => new Date(mensaje.PositionTime));
    const fechaInicial = new Date(Math.min(...fechas));
    const fechaFinal = new Date(Math.max(...fechas));
    const fechaFinalIndex = listaMensajes.findIndex(
      (mensaje) => new Date(mensaje.PositionTime).getTime() === fechaFinal.getTime()
    );
    // console.log("Fecha final index:", fechaFinalIndex);


    let mensajeDiferencia = null;
    let fechaAnterior = null;
    if (fechaFinalIndex > 0) {
      fechaAnterior = new Date(listaMensajes[fechaFinalIndex - 1].PositionTime);
      // console.log("Fecha anterior:", fechaAnterior);
    } else {
      console.error("No hay fecha anterior disponible.");
      mensajeDiferencia = "🚛 En geocerca";
    }

    // Calcular la diferencia entre la fecha de inicio y la fecha final
    const diferencia = fechaAnterior - fechaInicial;

    // Convertir la diferencia de milisegundos a días, horas, minutos y segundos
    const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));
    const horas = Math.floor((diferencia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));
    const segundos = Math.floor((diferencia % (1000 * 60)) / 1000);

    // Formatear la diferencia de tiempo
    const tiempoDiferencia = `${horas}h ${minutos}m ${segundos}s`;

    // Crear el contenido del InfoWindow con la fecha inicial, final y la diferencia
    const contentString = `
        <div>
          <h5>${geocerca.geocerca}</h4>
          <p><strong>Ingreso:</strong> ${formatFecha(fechaInicial)}</p>
          <p><strong>Salida:</strong> ${mensajeDiferencia ? mensajeDiferencia : formatFecha(fechaAnterior)}</p>
          ${mensajeDiferencia ? '' : `<p><strong>Duración en geocerca:</strong> ${tiempoDiferencia}</p>`}
        </div>
      `;

    // Crear y abrir el InfoWindow
    const infoWindow = new google.maps.InfoWindow({
      content: contentString,
      position: center,
    });

    infoWindow.open(mapRef.current);
  };




  //Funcion para dibujar geocercas en el mapa
  const dibujarGeocercas = () => {
    // Limpiar los polígonos previamente dibujados si es necesario
    geocercaPolygons.forEach(polygon => polygon.setMap(null));

    // Limpiar el array de polígonos
    setGeocercaPolygons([]);

    // Dibujar nuevos polígonos
    const newPolygons = uniquesGeocerca.map((geocerca) => {
      const vertices = geocerca.vertices.split('/');
      const coords = vertices.map((coord) => {
        const [lat, lng] = coord.replace(/[()]/g, '').split(',').map(Number);
        return { lat, lng };
      });

      const polygon = new google.maps.Polygon({
        paths: coords,
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 3,
        fillColor: "#FF0000",
        fillOpacity: 0.35,
      });

      polygon.setMap(mapRef.current);

      // Añadir un evento de clic al polígono
      google.maps.event.addListener(polygon, 'click', () => {
        // Mostrar información de la geocerca en un InfoWindow
        mostrarInformacionGeocerca(geocerca, polygon);
      });


      return polygon;
    });

    // Actualizar el estado de los polígonos
    setGeocercaPolygons(newPolygons);
  };


  useEffect(() => {
    if (switchValueGeo) {
      // Solo dibujar geocercas si el switch está activado
      dibujarGeocercas();
    } else {
      // Si el switch se desactiva, eliminamos los polígonos del mapa
      geocercaPolygons.forEach(polygon => polygon.setMap(null));
    }
  }, [switchValueGeo, uniquesGeocerca]);



  //(3.804092023012944,-76.6342724388831)/(3.801265846222622,-76.63058171927861)
  useEffect(() => {
    // console.log("Lista de mensajes actualizada:", listaMensajes);

    // Filtramos los valores null y extraemos las geocercas únicas
    const uniques = [...new Set(listaMensajes.map((objeto) => objeto.NombreGeocerca).filter(item => item !== null))];

    // Creamos un array de objetos con la asociación geocerca -> vertices
    const geocercaWithVertices = uniques.map((geocerca) => {
      // Buscar los vertices para la geocerca actual
      const objeto = listaMensajes.find((item) => item.NombreGeocerca === geocerca && item.Vertices);
      return objeto ? { geocerca, vertices: objeto.Vertices } : null;
    }).filter(item => item !== null); // Eliminamos los objetos nulos si no se encuentra Vertices para una geocerca

    // Actualizamos el estado con el array de objetos
    // console.log("Geocercas con Vertices:", geocercaWithVertices);
    setUniquesGeocerca(geocercaWithVertices);
    const b = contratoVar?.fechafin;
    const a = contratoVar?.fechainicio;

    if (a && b) {
      const fechaInicio = new Date(a);
      const fechaFin = new Date(b);
      const diferencia = fechaFin - fechaInicio;
      const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));
      const horas = Math.floor((diferencia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));
      const segundos = Math.floor((diferencia % (1000 * 60)) / 1000);
      setTimeTotal(`${dias}d ${horas}h ${minutos}m ${segundos}s`);
    }

  }, [listaMensajes]);

  const handleBackgroundListaMensajes = (mensaje) => {
    if (!mensaje) return "";

    const sinGps =
      Number(mensaje.latitude) === 0 || Number(mensaje.SatelliteCount) === 0;
    const sinSenal = Number(mensaje.csq) === 99;

    if (sinGps && sinSenal) {
      return "background-class2";
    }

    if (!sinGps && sinSenal) {
      return "background-class3";
    }

    if (sinGps && !sinSenal) {
      return "background-class";
    }

    return "";
  };




  if (!isOpen) return null;
  return (
    <div>
      <MDBRow style={{ marginTop: '-15px', marginBottom: '10px' }} className="seguimiento-links-row">
        <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', width: '100%' }}>
          <div style={{ display: 'flex', flexDirection: 'row' }} className="seguimiento-links">
            <a className="seguimiento-action-link" href="#" onClick={(e) => { imagesModal(e) }}><i className="bx bx-image" aria-hidden="true" />Imágenes IA</a>
            <a className="seguimiento-action-link" href="#" onClick={(e) => { streamingModal(e) }}><i className="bx bx-radio-circle-marked" aria-hidden="true" />Streaming</a>
            <a className="seguimiento-action-link" href="#" onClick={(e) => { valitronicsModal(e) }}><i className="bx bx-cube" aria-hidden="true" />Valitronics</a>
            <a className="seguimiento-action-link" href="#" onClick={(e) => { checkListModal(e) }}><i className="bx bx-check-square" aria-hidden="true" />Check List</a>
            <a className="seguimiento-action-link" href="#" onClick={(e) => { consolidadoModal(e) }}><i className="bx bx-file" aria-hidden="true" />Consolidado</a>
          </div>
        </div>
      </MDBRow>
      <MDBRow style={{ marginBottom: '10px' }}>
        <MDBCol md='5'>
          <nav class="navbar navbar-expand-lg custom-navbar seguimiento-topbar">
            <div class="container-fluid">
              <a class="navbar-brand" href="#" style={{ color: '#fff' }}>MENU</a>
              <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse" id="navbarNavDropdown" style={{ display: 'flex' }}>
                <ul class="navbar-nav">
                  <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ color: '#fff' }}>
                      Configuración
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                      <li onClick={handleVerUltPuntoClick}><a class="dropdown-item">Ver ultimo punto</a></li>
                      <li onClick={handleSetUltPunto}><a class="dropdown-item">Setear punto</a></li>
                    </ul>
                  </li>
                  <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ color: '#fff' }}>
                      Reportes
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink" style={{ width: "230px" }}>
                      <li onClick={handl50RecorrClick} style={{ cursor: "pointer" }}><a class="dropdown-item">Visualizar ultimos (50)</a></li>
                      {/* <li  ><a class="dropdown-item">Visualizar ultimos (100)</a></li>
                      <li  ><a class="dropdown-item">Visualizar ultimos (200)</a></li>
                      <li  ><a class="dropdown-item">Visualizar ultimos (500)</a></li> */}
                      <li onClick={handleTodoRecorridoClick} style={{ cursor: "pointer" }}><a class="dropdown-item">Visualizar todos los reportes</a></li>
                    </ul>
                  </li>
                  <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ color: '#fff' }}>
                      Trafico
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                      <li>
                        <a
                          class="dropdown-item"
                          onClick={handleSetReporteAutomatico}
                          style={{ cursor: "pointer" }}
                        >
                          Generar reporte automatico
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>

              </div>
            </div>
          </nav>
        </MDBCol>

        <MDBCol md='7'>
          <MDBRow className="seguimiento-kpis">
            <MDBCol md='4'>
              <div className="seguimiento-kpi-card" style={{ fontFamily: 'Courier New, sans-serif' }}>
                <FaClock size={18} className='icono rounded' /> Inicio:<br />
                {listaMensajes?.length > 0 ? contratoVar?.fechainicio : "Sin datos"}
              </div>
            </MDBCol>
            <MDBCol md='4'>
              <div className="seguimiento-kpi-card" style={{ fontFamily: 'Courier New, sans-serif' }}>
                <FaClock size={18} className='icono' /> Fin:<br />
                {listaMensajes?.length > 0 ? contratoVar?.fechafin : "Sin datos"}
              </div>
            </MDBCol>
            <MDBCol md='4'>
              <div id="contenedorestadodiv" className="seguimiento-kpi-card" style={{ fontFamily: 'Courier New, sans-serif' }}>
                <FaLock size={18} className='icono' /> Duración total:<br />
                {timeTotal ? timeTotal : "Sin datos"}
              </div>
            </MDBCol>
          </MDBRow>
        </MDBCol>

      </MDBRow>
      <MDBRow className="seguimiento-content-row">
        <MDBCol md='5'>
          <div className="seguimiento-map-shell" style={{ position: "relative" }}>
            <div id="map" className="seguimiento-map" />
            {loadingSeguimiento && (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  background: "rgba(255, 255, 255, 0.72)",
                  backdropFilter: "blur(1px)",
                  zIndex: 5,
                  borderRadius: "18px",
                }}
              >
                <Spinner color="primary" />
                <div style={{ fontSize: "14px", fontWeight: 600, color: "#1f3b57" }}>
                  Cargando mensajes y marcadores...
                </div>
              </div>
            )}
          </div>

        </MDBCol>
        <MDBCol md='7' className="seguimiento-panel seguimiento-content-panel">
          <MDBRow className="seguimiento-switches">
            <MDBCol md='12'>
              <div style={{ overflow: 'hidden', width: '100%' }}>
                <motion.div
                  id="informacioneventos"
                  className="scrolling-text"
                  initial={{ x: '100%' }}
                  animate={{ x: '-100%' }}
                  transition={{
                    duration: 10,
                    repeat: Infinity,
                    ease: 'linear',
                  }}
                >
                </motion.div>
              </div>
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol md='12'>
              <div className="form-check form-switch custom-switch">
                <input className="form-check-input" type="checkbox" role="switch" id="Geocerca" checked={switchValueGeo} onChange={handleSwitchChangeGeo} />
                <label className="form-check-label" for="autocentrado">Geocercas</label>
              </div>
            </MDBCol>
          </MDBRow>

          <div className="container containerReporteSeguimiento seguimiento-meta-card" id="contenedor" style={{ fontSize: '10px' }}>

            <div className="row py-1">
              <div className="col">
                <b style={{ fontSize: '12px' }}>DISPOSITIVO:</b>
                <div style={{ fontSize: '12px' }} id="dispositivo_segH">
                </div>
              </div>

              <div className="col">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    gap: "12px",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ minWidth: "120px", flex: "1 1 120px" }}>
                    <b style={{ fontSize: '12px' }}>CONTRATO:</b>
                    <div style={{ fontSize: '12px' }} id="contrato_segH">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row py-1">
              <div className="col">
                <b style={{ fontSize: '12px' }}>CLIENTE:</b>
                <div style={{ fontSize: '12px' }} id="cliente_segH"></div>
              </div>
              <div className="col d-flex align-items-center justify-content-between">
                <div>
                  <b style={{ fontSize: '12px' }}>RUTA:</b>
                  <div style={{ fontSize: '12px' }} id="ruta_segH"></div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleExportarExcel}
                    disabled={loadingSeguimiento || exportandoExcel}
                    style={{
                      minHeight: "38px",
                      padding: "0 14px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      fontWeight: 700,
                      fontSize: "13px",
                      borderRadius: "999px",
                      whiteSpace: "nowrap",
                      boxShadow: "0 8px 18px rgba(17, 52, 77, 0.10)",
                    }}
                  >
                    {exportandoExcel ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ width: "0.95rem", height: "0.95rem", borderWidth: "0.16em" }}
                      ></span>
                    ) : (
                      <FaFileExcel size={15} aria-hidden="true" style={{ flexShrink: 0 }} />
                    )}
                    {exportandoExcel ? "Exportando..." : "Exportar Excel"}
                  </button>
                  <FaInfoCircle
                    size={20}
                    color="#007bff"
                    onClick={() => setModalInformacionExtra(true)}
                    style={{ cursor: 'pointer' }} />
                </div>
              </div>
            </div>



            <div className="containerReporte containerReporteContratoSeguimiento seguimiento-table-card" style={{ height: "390px", overflow: "hidden", width: "100%", maxWidth: "100%", position: "relative", display: "flex", flexDirection: "column" }}>
              {/* Pestañas */}
              {loadingSeguimiento && (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    background: "rgba(255, 255, 255, 0.82)",
                    zIndex: 4,
                  }}
                >
                  <Spinner color="primary" />
                  <div style={{ fontSize: "14px", fontWeight: 600, color: "#1f3b57" }}>
                    Cargando lista de mensajes...
                  </div>
                </div>
              )}
              <div className="tabs">
                <button
                  type="button"
                  className={`tab ${activeTab === "tabla" ? "active" : ""}`}
                  onClick={() => setActiveTab("tabla")}
                >
                  Lista mensajes
                </button>
              </div>

              {/* Contenido de las pestañas */}
              <div
                className="content"
                style={{ flex: "1 1 auto", minHeight: 0, overflow: "hidden" }}
              >
                {activeTab === "tabla" ? (
                  <div className="message-table-scroll contrato-mensajes-scroll">
                  <table className="tableReporteContratoSeguimiento contrato-mensajes-table" style={{ width: "100%", minWidth: "586px", tableLayout: "fixed" }}>
                    <colgroup>
                      <col style={{ width: "50px" }} />
                      <col style={{ width: "50px" }} />
                      <col style={{ width: "80px" }} />
                      <col style={{ width: "90px" }} />
                      <col style={{ width: "80px" }} />
                      <col style={{ width: "28px" }} />
                      <col style={{ width: "28px" }} />
                      <col style={{ width: "40px" }} />
                      <col style={{ width: "32px" }} />
                      <col span="6" style={{ width: "18px" }} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th className="sticky-header" style={{ width: "50px", textAlign: "center" }}>Fecha</th>
                        <th className="sticky-header" style={{ width: "50px", textAlign: "center" }}>Guardado</th>
                        <th className="sticky-header" style={{ width: "80px", textAlign: "center" }}>Lugar</th>
                        <th className="sticky-header" style={{ width: "90px", textAlign: "center" }}>Evento</th>
                        <th className="sticky-header" style={{ width: "80px", textAlign: "center" }}>Geocerca</th>
                        <th className="sticky-header" style={{ width: "28px", textAlign: "center" }}>Bat</th>
                        <th className="sticky-header" style={{ width: "28px", textAlign: "center" }}>Gps</th>
                        <th className="sticky-header" style={{ width: "40px", textAlign: "center" }}>Vel</th>
                        <th className="sticky-header" style={{ width: "32px", textAlign: "center" }}>Csq</th>
                        <th
                          className="sticky-header icon-group-header"
                          colSpan={6}
                          style={{ width: "108px", textAlign: "center", padding: "4px" }}
                        >
                          <details className="icon-filter-dropdown">
                            <summary title="Filtrar por icono">
                              <span className="icon-filter-summary-content">
                                {activeIconFilter ? (
                                  <img src={activeIconFilter} alt={getIconOptionLabel(activeIconFilter)} width={18} height={18} />
                                ) : (
                                  <span className="icon-filter-placeholder" />
                                )}
                                <span className="icon-filter-summary-label">
                                  {activeIconFilter ? getIconOptionLabel(activeIconFilter) : "Todos los iconos"}
                                </span>
                              </span>
                              <span className="icon-filter-chevron">▼</span>
                            </summary>
                            <div className="icon-filter-menu">
                              <button
                                type="button"
                                className={`icon-filter-option ${!activeIconFilter ? "active" : ""}`}
                                onClick={(event) => {
                                  clearIconFilter();
                                  event.currentTarget.closest("details")?.removeAttribute("open");
                                }}
                              >
                                <span className="icon-filter-placeholder" />
                                <span>Todos los iconos</span>
                              </button>
                              {uniqueIconPaths.map((path) => (
                                <button
                                  type="button"
                                  key={path}
                                  className={`icon-filter-option ${path === activeIconFilter ? "active" : ""}`}
                                  onClick={(event) => {
                                    filterMarkersByIcon(path);
                                    event.currentTarget.closest("details")?.removeAttribute("open");
                                  }}
                                >
                                  <img src={path} alt={getIconOptionLabel(path)} width={18} height={18} />
                                  <span>{getIconOptionLabel(path)}</span>
                                </button>
                              ))}
                            </div>
                          </details>
                          
                          <div style={{ display: "none", justifyContent: "center", gap: "4px" }}>
                            {uniqueIconPaths.map((path) => (
                              <img
                                key={path}
                                src={path}
                                width={18}
                                height={18}
                                style={{
                                  cursor: "pointer",
                                  opacity: path === activeIconFilter ? 1 : 0.4,
                                  border: path === activeIconFilter ? "2px solid #007bff" : "2px solid transparent",
                                  borderRadius: 2,
                                }}
                                onClick={() => filterMarkersByIcon(path)}
                              />
                            ))}
                            <i
                              className="bx bx-x-circle"
                              style={{
                                fontSize: 20,
                                cursor: "pointer",
                                marginLeft: 12,
                                opacity: activeIconFilter ? 1 : 0.3,
                                color: "#d00",
                              }}
                              onClick={clearIconFilter}
                              title="Limpiar filtro"
                            />
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {listaFiltrada.map((objeto, index) => (
                        <tr
                          key={objeto.ID}
                          className={handleBackgroundListaMensajes(objeto)}
                          onClick={() => handleTableRowClick(index)}
                        >
                          <td style={{ padding: "5px" }}>{formatFecha(objeto.PositionTime)}</td>
                          <td style={{ padding: "5px" }}>{objeto.DateTimeActualizacion ? formatFecha(objeto.DateTimeActualizacion) : ""}</td>
                          <td>{objeto.latitude === 0 ? <b>SIN GPS</b> : objeto.Ciudad}</td>
                          <td style={{ padding: "5px" }}>{objeto.Evento ?? ""}</td>
                          <td style={{ paddingLeft: "5px" }}>{objeto.NombreGeocerca}</td>
                          <td style={{ textAlign: "center" }}>{parseFloat(objeto.Battery).toFixed(2).replace(/\.?0+$/, "")}</td>
                          <td style={{ textAlign: "center" }}>{objeto.SatelliteCount}</td>
                          <td style={{ padding: "5px" }}>{objeto.Speed}</td>
                          <td style={{ textAlign: "center" }}>{objeto.csq ?? ""}</td>
                          <td className="icon-cell"><img src={objeto.IconSatelite.substring(1)} width="18" height="18" /></td>
                          <td className="icon-cell"><img src={objeto.IconMoving.substring(1)} width="18" height="18" /></td>
                          <td className="icon-cell"><img src={objeto.IconLocked.substring(1)} width="18" height="18" /></td>
                          <td className="icon-cell"><img src={objeto.IconDesvio.substring(1)} width="18" height="18" /></td>
                          <td className="icon-cell"><img src={objeto.IconBack.substring(1)} width="18" height="18" /></td>
                          <td className="icon-cell"><img src={objeto.IconAlejado.substring(1)} width="18" height="18" /></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  </div>
                ) : null}
              </div>

              {/* Estilos */}
              <style jsx>{`
        .containerReporte {
          display: flex;
          flex-direction: column;
          margin: 0;
          width: 100%;
          max-width: 100%;
          border-radius: 5px;
          box-sizing: border-box;
        }

        .tabs {
          display: flex;
          gap: 5px;
          border-bottom: 2px solid #ddd;
          padding-bottom: 5px;
        }

        .tab {
          background: #f0f0f0;
          padding: 8px 16px;
          border: none;
          cursor: pointer;
          border-radius: 5px 5px 0 0;
          transition: all 0.3s;
        }

        .tab.active {
          background: linear-gradient(135deg, #0b5c8f 0%, #1b84c5 100%);
          color: white;
          font-weight: bold;
        }

        .content {
          display: flex;
          flex-direction: column;
          flex: 1 1 auto;
          min-height: 0;
          width: 100%;
          box-sizing: border-box;
        }

                .seguimiento-content-row {
                  align-items: stretch;
                }

                .seguimiento-content-row > [class*="col-"] {
                  display: flex;
                  min-height: 0;
                }

                .seguimiento-map-shell {
                  display: flex;
                  flex: 1 1 auto;
                  min-height: 0;
                  width: 100%;
                }

                .seguimiento-content-row .seguimiento-map {
                  width: 100%;
                  height: 100%;
                  min-height: 0 !important;
                }

                .seguimiento-content-panel {
                  display: flex;
                  flex-direction: column;
                }

        .message-table-scroll {
          position: relative;
          flex: 1 1 auto;
          min-height: 0;
          overflow-y: auto;
          overflow-x: auto;
          scrollbar-gutter: stable;
        }

        .contrato-mensajes-scroll {
          position: relative;
          height: 0;
          flex: 1 1 0;
          overflow-y: auto !important;
          overflow-x: auto !important;
          isolation: isolate;
        }

        .tableReporteContratoSeguimiento {
          width: 100%;
          min-width: 586px;
          table-layout: fixed;
          border-collapse: collapse;
          border-spacing: 0;
        }

        .contrato-mensajes-table {
          width: 100% !important;
          min-width: 586px !important;
          table-layout: fixed !important;
          border-collapse: collapse;
          overflow: visible !important;
        }

        .tableReporteContratoSeguimiento th,
        .tableReporteContratoSeguimiento td {
          box-sizing: border-box;
          font-size: 11px;
          word-break: break-word;
          overflow-wrap: anywhere;
          text-align: center;
          vertical-align: middle;
          padding: 5px 4px;
        }

        .tableReporteContratoSeguimiento th:nth-child(1),
        .tableReporteContratoSeguimiento td:nth-child(1) { width: 50px; min-width: 50px; }
        .tableReporteContratoSeguimiento th:nth-child(2),
        .tableReporteContratoSeguimiento td:nth-child(2) { width: 50px; min-width: 50px; }
        .tableReporteContratoSeguimiento th:nth-child(3),
        .tableReporteContratoSeguimiento td:nth-child(3) { width: 80px; min-width: 80px; }
        .tableReporteContratoSeguimiento th:nth-child(4),
        .tableReporteContratoSeguimiento td:nth-child(4) { width: 90px; min-width: 90px; }
        .tableReporteContratoSeguimiento th:nth-child(5),
        .tableReporteContratoSeguimiento td:nth-child(5) { width: 80px; min-width: 80px; }
        .tableReporteContratoSeguimiento th:nth-child(6),
        .tableReporteContratoSeguimiento td:nth-child(6) { width: 28px; min-width: 28px; }
        .tableReporteContratoSeguimiento th:nth-child(7),
        .tableReporteContratoSeguimiento td:nth-child(7) { width: 28px; min-width: 28px; }
        .tableReporteContratoSeguimiento th:nth-child(8),
        .tableReporteContratoSeguimiento td:nth-child(8) { width: 40px; min-width: 40px; }
        .tableReporteContratoSeguimiento th:nth-child(9),
        .tableReporteContratoSeguimiento td:nth-child(9) { width: 32px; min-width: 32px; }
        .tableReporteContratoSeguimiento th:nth-child(n + 10),
        .tableReporteContratoSeguimiento td:nth-child(n + 10) { width: 18px; min-width: 18px; max-width: 18px; }

        .tableReporteContratoSeguimiento thead th {
          position: sticky !important;
          top: 0 !important;
          z-index: 10 !important;
          background: #0b5c8f !important;
          background-clip: padding-box;
          box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.18);
        }

        .contrato-mensajes-table thead th {
          position: sticky !important;
          top: 0 !important;
          z-index: 20 !important;
          background: #0b5c8f !important;
          color: #fff !important;
        }

        .tableReporteContratoSeguimiento thead {
          position: sticky;
          top: 0;
          z-index: 9;
        }

        .tableReporteContratoSeguimiento .icon-group-header {
          min-width: 108px;
        }

        .tableReporteContratoSeguimiento .icon-filter-dropdown {
          position: relative;
          width: 100%;
        }

        .tableReporteContratoSeguimiento .icon-filter-dropdown summary {
          list-style: none;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 6px;
          width: 100%;
          min-height: 30px;
          padding: 5px 8px;
          border-radius: 8px;
          border: 1px solid rgba(255, 255, 255, 0.45);
          background: rgba(255, 255, 255, 0.14);
          cursor: pointer;
        }

        .tableReporteContratoSeguimiento .icon-filter-dropdown summary::-webkit-details-marker {
          display: none;
        }

        .tableReporteContratoSeguimiento .icon-filter-summary-content {
          display: flex;
          align-items: center;
          gap: 6px;
          min-width: 0;
        }

        .tableReporteContratoSeguimiento .icon-filter-summary-label {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #fff;
          font-size: 11px;
          font-weight: 600;
        }

        .tableReporteContratoSeguimiento .icon-filter-placeholder {
          display: inline-block;
          width: 18px;
          height: 18px;
          min-width: 18px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.4);
        }

        .tableReporteContratoSeguimiento .icon-filter-chevron {
          color: #fff;
          font-size: 10px;
          line-height: 1;
        }

        .tableReporteContratoSeguimiento .icon-filter-menu {
          position: absolute;
          top: calc(100% + 4px);
          left: 0;
          right: 0;
          z-index: 20;
          display: flex;
          flex-direction: column;
          gap: 2px;
          max-height: 220px;
          overflow-y: auto;
          padding: 6px;
          border-radius: 10px;
          background: #fff;
          box-shadow: 0 12px 24px rgba(16, 43, 67, 0.2);
        }

        .tableReporteContratoSeguimiento .icon-filter-option {
          display: flex;
          align-items: center;
          gap: 8px;
          width: 100%;
          padding: 6px 8px;
          border: none;
          border-radius: 8px;
          background: transparent;
          color: #16324a;
          font-size: 11px;
          text-align: left;
          cursor: pointer;
        }

        .tableReporteContratoSeguimiento .icon-filter-option.active {
          background: rgba(27, 132, 197, 0.12);
          font-weight: 700;
        }

        .tableReporteContratoSeguimiento .icon-filter-option:hover {
          background: rgba(27, 132, 197, 0.08);
        }

        .tableReporteContratoSeguimiento .icon-cell {
          width: 18px;
          min-width: 18px;
          max-width: 18px;
          padding: 4px 2px !important;
          text-align: center;
          overflow: hidden;
        }

        .tableReporteContratoSeguimiento .icon-cell img {
          display: inline-block;
          vertical-align: middle;
        }

        @media (max-width: 768px) {
          .containerReporte {
            padding: 0 10px;
          }

          .tab {
            padding: 6px 12px;
          }
        }
      `}</style>
            </div>

          </div>

        </MDBCol>

      </MDBRow>
      <BaseModalAuto2
        isOpen={modalInformacionExtra}
        onClose={() => setModalInformacionExtra(false)}
        size={80}
        // onMouseEnter / onMouseLeave para que no se cierre si pasamos el mouse al modal
        // onMouseEnter={handleMouseEnter}
        // onMouseLeave={handleMouseLeave}
        title=""
      >
        <ModalInfromacionExtra contrato={contratoVar} />
      </BaseModalAuto2 >
      {/* <div className="alert alert-success" id="success-alert">
        <strong>Exitoso! </strong> Los cambios han sido realizados con exito.
      </div>

      <div className="alert alert-danger" id="danger-alert">
        <strong>Error! </strong> Se ha presentado un error, valide la información.
      </div> */}
    </div>
  );
};

export default Modal;
